const PROJECTS = [
  {
    key: 'trionfi',
    title: 'Trionfi',
    prefix: 'TRI',
    count: 120,
    color: '#ff6b28',
    center: [-7.2, 3.6],
    radius: 5.2,
    projectPath: '/projects/trionfi',
    firstYear: 2026,
  },
  {
    key: 'labyrinth-scarf',
    title: 'Labyrinth Scarf',
    prefix: 'LAB',
    count: 48,
    color: 'hotpink',
    center: [7.2, 3.2],
    radius: 4.4,
    projectPath: '/projects/labyrinth-scarf',
    firstYear: 2021,
  },
  {
    key: 'hope-blanket',
    title: 'Hope Baby Blanket',
    prefix: 'HOP',
    count: 14,
    color: 'green',
    center: [-2.2, -6.3],
    radius: 2.8,
    projectPath: '/projects/hope-blanket',
    firstYear: 2026,
  },
  {
    key: 'costume-parisien',
    title: 'Costume Parisien',
    prefix: 'COS',
    count: 1,
    color: 'darkslateblue',
    center: [6.1, -5.8],
    radius: 0.3,
    projectPath: '/projects/costume-parisien',
    firstYear: 2024,
  },
];

function mulberry32(seed) {
  return function random() {
    let value = (seed += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

function pad(value) {
  return String(value).padStart(4, '0');
}

function makeObjects() {
  const random = mulberry32(19062019);
  const objects = [];

  PROJECTS.forEach((project) => {
    for (let index = 0; index < project.count; index += 1) {
      const angle = random() * Math.PI * 2;
      const distance = Math.sqrt(random()) * project.radius;
      const x = project.center[0] + Math.cos(angle) * distance;
      const z = project.center[1] + Math.sin(angle) * distance;
      const baseY = 0.55 + random() * 2.9;
      const year = project.firstYear + Math.min(5, Math.floor(index / 36));

      objects.push({
        id: `${project.key}-${index + 1}`,
        title:
          project.count === 1
            ? project.title
            : `${project.title} No. ${pad(index + 1)}`,
        project: project.title,
        projectKey: project.key,
        projectPath: project.projectPath,
        accessionNumber: `${project.prefix}.${year}.${pad(index + 1)}`,
        color: project.color,
        position: [x, baseY, z],
        phase: random() * Math.PI * 2,
        speed: 0.35 + random() * 0.55,
        amplitude: 0.08 + random() * 0.28,
        scale: project.count === 1 ? 1.75 : 0.72 + random() * 0.55,
        visibility: 'Public prototype record',
      });
    }
  });

  return objects;
}

export const palaisObjects = makeObjects();

export const palaisProjectCounts = PROJECTS.map((project) => ({
  key: project.key,
  title: project.title,
  count: project.count,
  color: project.color,
}));
